<nav class="navbar navbar-expand-lg bg-header d-flex justify-content-between align-items-center" id="bg-blur">
  <!--<a class="navbar-brand lead ps-3" href=""> <strong class="fs-5 font-monospace">AI</strong>ignment</a>
  Toggle Button (navbar-toggler ml-5)-->
  <a class="navbar-brand lead ps-3 brand-link" routerLink="/">
    <img class="brand-logo" src="assets/mals-logo.png" alt="MALS Logo">
    <span class="brand-title">Mastering Ascendancy Leadership Spectrum</span>
  </a>
  <!--<button class="btn btn-link" *ngIf="authService.isLoggedIn()"
          type="button" (click)="toggleSidebar()"
          data-toggle="collapse" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
  </button>-->

  <a class="website-link ms-auto me-3 d-none d-md-inline-flex" [href]="globals.websiteUrl">
    <span class="website-link__arrow" aria-hidden="true">←</span>Mastering Emotions
  </a>

  <div class="language-switch ms-auto ms-md-0 me-2" role="group" [attr.aria-label]="'Switch language' | t">
    <button type="button" class="language-option"
            [class.active]="language.currentLanguage === 'en'"
            [attr.aria-pressed]="language.currentLanguage === 'en'"
            (click)="language.setLanguage('en')">EN</button>
    <span aria-hidden="true">|</span>
    <button type="button" class="language-option"
            [class.active]="language.currentLanguage === 'de'"
            [attr.aria-pressed]="language.currentLanguage === 'de'"
            (click)="language.setLanguage('de')">DE</button>
  </div>

  <form class="d-none d-md-inline-block form-inline me-0 me-md-3 my-2 my-md-0">
    <!-- <div class="input-group" *ngIf="authService.isLoggedIn()">
         <div class="sidebar-search pt-1 pb-1 pl-3 pr-3">
             <input class="form-control rounded-pill" name="search" placeholder="Search ..." type="search">
         </div>
     </div>-->
    <div *ngIf="!authService.isLoggedIn()">
      <ul class="navbar-nav mr-5">
        <a class="nav-link" *ngIf="!authService.isLoggedIn()" routerLink="/login" routerLinkActive="active">{{ 'Login' | t }}</a>
        <a class="nav-link" *ngIf="!authService.isLoggedIn()" routerLink="/register"
           routerLinkActive="active">{{ 'Register' | t }}</a>
      </ul>
    </div>
  </form>

  <!-- Dropdown Toggle Items-->
  <ul class="navbar-nav ms-auto ms-md-0 me-3 me-lg-4" *ngIf="authService.isLoggedIn()">
    <li class="nav-item dropdown text-decoration-none">
      <jw-dropdown-blase></jw-dropdown-blase>
    </li>
  </ul>
</nav>
